// extracted by css-extract-rspack-plugin
export default {"footer":"IssueFieldPicker-module__footer__yTK0h8z"};